import { render, staticRenderFns } from "./SearchDept.vue?vue&type=template&id=42c1a2f8&scoped=true"
import script from "./SearchDept.vue?vue&type=script&lang=js"
export * from "./SearchDept.vue?vue&type=script&lang=js"
import style0 from "./SearchDept.vue?vue&type=style&index=0&id=42c1a2f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c1a2f8",
  null
  
)

export default component.exports